import {
  CHANGE_COMPANY_SEARCH_KEYWORD,
  FAILURE_CREATE_COMPANY,
  FAILURE_SEARCH_COMPANIES,
  FILTER_COMPANIES,
  REQUEST_CREATE_COMPANY,
  REQUEST_SEARCH_COMPANIES,
  SET_SEARCH_COMPANY_DEMO_PARAMS,
  SET_SEARCH_COMPANY_STATUS,
  SUCCESS_CREATE_COMPANY,
  SUCCESS_SEARCH_COMPANIES,
} from 'actions/actionTypes';
import { CompanyActionTypes, CompanyState } from 'types/backyard/company';
import calculatePageList from '../../utils/calculatePageList';

export const initialState: CompanyState = {
  isInitializedCompanies: false,
  companies: [], // サイドバー
  displayCompanies: [], // テーブル
  companySize: 0,
  currentPage: 1,
  currentPageCompanyList: '',
  filteredCompanies: [],
  companySearchKeyword: '',
  searchKeyword: undefined,
  searchDemoParams: undefined,
  searchStatus: undefined,
};

const backyardCompanyReducer = (state = initialState, action: CompanyActionTypes): CompanyState => {
  switch (action.type) {
    case SET_SEARCH_COMPANY_DEMO_PARAMS: {
      const { demoParam } = action;
      return {
        ...state,
        searchDemoParams: demoParam,
      };
    }
    case SET_SEARCH_COMPANY_STATUS: {
      const { status } = action;
      return {
        ...state,
        searchStatus: status,
      };
    }
    case REQUEST_SEARCH_COMPANIES: {
      const { searchWord } = action;
      if (typeof searchWord === 'string') {
        return {
          ...state,
          searchKeyword: searchWord,
        };
      }
      return {
        ...state,
      };
    }
    case SUCCESS_SEARCH_COMPANIES: {
      const { payload, size, pageNumber } = action;
      const calculatedPageList = calculatePageList(payload, pageNumber);
      return {
        ...state,
        isInitializedCompanies: true,
        displayCompanies: payload,
        companySize: size,
        currentPage: pageNumber || 1,
        currentPageCompanyList: calculatedPageList,
      };
    }
    case FAILURE_SEARCH_COMPANIES: {
      return {
        ...state,
        isInitializedCompanies: true,
      };
    }
    case CHANGE_COMPANY_SEARCH_KEYWORD: {
      const { keyword } = action;
      return {
        ...state,
        companySearchKeyword: keyword,
      };
    }
    case FILTER_COMPANIES: {
      const { filteredCompanies } = action;
      return {
        ...state,
        filteredCompanies,
      };
    }
    case REQUEST_CREATE_COMPANY: {
      return {
        ...state,
      };
    }
    case SUCCESS_CREATE_COMPANY: {
      const { payload } = action;
      return {
        ...state,
        companies: [...state.companies, payload],
      };
    }
    case FAILURE_CREATE_COMPANY: {
      return {
        ...state,
      };
    }
    default: {
      return state;
    }
  }
};

export default backyardCompanyReducer;
